import React from "react";
import FormatDate from "./FormatDate";
import WeatherIcon from "./WeatherIcon";
import WeatherUnit from "./WeatherUnit";

export default function WeatherInfo(props) {
  return (
    <div className="weather-info">
      <div className="row actual-town">
        <div className="col-6">
          <p>{props.info.city}</p>
        </div>
        <div className="col-6 actual-date">
          <FormatDate date={props.info.date} />
        </div>
      </div>
      <div className="row main">
        <div className="col-6 main-temp">
          <span className="main-icon">
            <WeatherIcon code={props.info.icon} size={64} />
          </span>
          <WeatherUnit celsius={props.info.temperature} />
        </div>
        <div className="col-6">
          <ul>
            <li className="row main-li">
              <div className="col-6 label">Wind</div>
              <div className="col-6 value">
                {Math.round(props.info.wind)} m/s
              </div>
            </li>
            <li className="row main-li">
              <div className="col-6 label">Humidity</div>
              <div className="col-6  value">{props.info.humidity}%</div>
            </li>
            <li className="row main-li">
              <div className="col-6 label">Visibility</div>
              <div className="col-6 value">
                {props.info.visibility / 1000} km
              </div>
            </li>
            <li className="last-li text-capitalize main-li">
              {props.info.cloud}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
